import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        <li className="flex items-center gap-2">
          <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />
            {item.path && index !== items.length - 1 ? (
              <Link
                to={item.path}
                className="hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}